<template lang="pug">
  div(class="navigation")
    div(class="navigation-inner")
      navigation-item(v-for="(item, index) in items" :item="item" :key="index + 1" @selection="select")
      div(class="navigation-handle" :style="transform")
        div(class="navigation-handle-inner")
          span {{ items[selected - 1].year }}
</template>

<script>
import navigationItem from './navigation-item'
export default {
  name: 'navigation',
  props: ['items', 'selected'],
  data () {
    return {
      duration: 0
    }
  },
  computed: {
    transform () {
      return {
        transform: 'translateX(' + this.factor + 'em)'
      }
    },
    factor () {
      return (this.selected - 1) * 10
    }
  },
  methods: {
    select (item) {
      let duration = Math.abs(this.selected - item.id) * 1000
      this.duration = duration
      // console.log(duration)
      this.$emit('animating', duration)
      this.$emit('selection', item)
    }
  },
  components: {
    navigationItem
  }
}
</script>

<style lang="stylus">
.navigation
  position: absolute;
  bottom: 3em
  left: 0
  right: 0
  display: flex
  z-index: 30
  transition: transform 300ms ease
  @media (max-height: 800px)
    transform: translateY(2em);
    font-size: 0.8em
  &-inner
    height: 6em
    display: flex
    margin: auto
    position: relative
    font-size: 0.6em
    @media (max-width: 1100px)
      font-size: 0.8vw
    &:before
      content: ''
      position: absolute
      top: 0
      bottom: 0
      background: rgba(0, 0, 0, 0.65)
      transform: skewX(-18deg)
      left: -5em
      right: -5em
      @media (max-width: 1800px)
        left: 0
        right: 0
  &-handle
    color: black
    position: absolute;
    width: 10em
    height: 100%
    cursor: pointer;
    transition: transform 300ms ease
    &:before
      content: ''
      position: absolute
      top: 0
      left: 0
      bottom: 0
      right: 0
      background: #ffe500
      transform: skewX(-18deg)
    &-inner
      display: flex
      justify-content: center
      align-items: center
      height: 100%
      position: relative
      & span
        font-size: 2em
        user-select: none
</style>



// WEBPACK FOOTER //
// src/components/navigation.vue